module.exports = __webpack_public_path__ + "82b15387a490d978decd81b93f05aba8.pdf";